import React from "react";
import { Disc3, ListMusic, Settings } from "lucide-react";

export default function FooterNav({ tab, setTab }) {
  const items = [
    { key: "dj", label: "DJ", icon: Disc3 },
    { key: "playlist", label: "Playlist", icon: ListMusic },
    { key: "settings", label: "Settings", icon: Settings },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 backdrop-blur-xl bg-black/70 border-t border-white/10"
      style={{ boxShadow: "0 -8px 32px rgba(0,0,0,0.5)" }}
    >
      <div className="max-w-5xl mx-auto grid grid-cols-3">
        {items.map((it) => {
          const active = tab === it.key;
          const Icon = it.icon;
          return (
            <button
              key={it.key}
              onClick={() => setTab(it.key)}
              className="relative py-3 flex flex-col items-center gap-1 transition-all"
              data-testid={`nav-${it.key}`}
            >
              <Icon
                className={`w-5 h-5 transition-all ${
                  active ? "text-white" : "text-zinc-500"
                }`}
              />
              <span
                className={`font-mono text-[9px] tracking-[0.2em] font-bold ${
                  active ? "text-white" : "text-zinc-500"
                }`}
              >
                {it.label.toUpperCase()}
              </span>
              {active && (
                <div
                  className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-t"
                  style={{
                    background:
                      it.key === "dj"
                        ? "linear-gradient(90deg,#d946ef,#06b6d4)"
                        : it.key === "playlist"
                        ? "#d946ef"
                        : "#06b6d4",
                    boxShadow: "0 0 10px currentColor",
                  }}
                />
              )}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
